export default __webpack_public_path__ + "static/media/next-track.6bc23a98.png";